import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  state() {
    return {
      userInfo: {
        userId: null,
        userName: null,
        department: null,
      },
      versionData: null,
      needsRefresh: false,
      token: null,
      didAutoLogout: false,
      rules: [],
    };
  },
  mutations,
  actions,
  getters,
};
